<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="900px"
      :fullscreen="fullscreen"
      :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">来款登记</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm7>
                <v-text-field
                    label="来款摘要"
                    required
                    :rules="rules.required"
                    counter="150"
                    v-model="item.zy"/>
              </v-flex>

              <v-flex xs12 sm5>
                <v-text-field
                    label="汇款单位"
                    clearable
                    required
                    :rules="rules.required"
                    v-model="item.dfdw"
                />
              </v-flex>

              <v-flex xs3>
                <v-text-field
                    label="来款金额"
                    required
                    :rules="rules.je"
                    v-model="item.je"
                    hint="单位：元"
                    persistent-hint
                />
              </v-flex>

              <v-flex xs12 sm4>
                <v-select
                    label="资金性质"
                    clearable
                    required
                    v-model="item.lkbz"
                    item-text="name"
                    item-value="dbid"
                    :items="lkbzItems"
                />
              </v-flex>

              <v-flex xs5>
                <v-menu
                    ref="lkrqMenuRef"
                    lazy
                    :close-on-content-click="false"
                    v-model="lkrqMenu"
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    max-width="290px"
                >
                  <v-text-field
                      slot="activator"
                      label="来款时间"
                      v-model="item.lkrq"
                      :rules="rules.lkrq"
                      hint="格式YYYY-MM-DD, 如：2018-10"
                      persistent-hint
                  />

                  <v-date-picker
                      v-model="lkrq"
                      locale="zh-cn"
                      @change="onSelectDate"
                  />
                </v-menu>
              </v-flex>



            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin'
const baseURI = '/api/proj/incoclaim/';
export default {
  mixins: [mixin.edit(baseURI)],
  name: "Edit.vue",
  data() {
    return {
      formValid: false,

      lkrqMenu: false,
      lkrq:null,

      searchdfdw:null,


      item:{},
      //freshItem中引号包括的model名称为scala中表格定义的字段名，在mixin的index中，freshItem被克隆给item,故freshItem的model可以被item引用
      freshItem: {
        "zy": null,
        "dfdwId" : null,
        "je": null,
        "lkrq": null,
        "pznm": null,
        "flbh": null,
        "kmbh": null,
        "bmbh": null,
        "xmbh": null,
        "dch": null,
        "zrr": null,
        "dfdw": null,
        "pzbh": null,
        "pzrq": null,
        "lxbh": null,
        "zdr": null,
        "jsdh": null,
        "lklx": null,
        "lsh": null,
        "jsbh": null,
        "lkbz": null,
      },


      dfdwItems: [],
      lkbzItems: ["财政","非财政","学校配套"],

      /**
       * 验证规则
       */
      rules: {
        required: [
          v => !!v || '必填项。'
        ],
        je: [
          v => !!v || '必填项。',
          v => (v && /^\d+(\.\d{1,2})?$/.test(v)) || '填写整数或小数,小数点后最多两位。'
        ],
        incoDate: [
          v => !!v || "必填项。",
          v => window.xutil.regexpDate().test(v) || '日期格式错误'
        ],
      }

    }
  },
  created() {
    const now = new Date()
    const yy = now.getFullYear()
    const mm = now.getMonth()+1
    const dd = now.getDate()
    const hh = now.getHours()
    const mf = now.getMinutes() < 10 ? '0'+now.getMinutes() : now.getMinutes()
    let MM = ''
    let DD = ''
    if(mm < 10)
    {
      MM = '0'+mm
    }
    if(dd < 10)
    {
      DD = '0'+dd
    }
    else {
      DD = dd
    }

    this.freshItem.flbh = '1'
    this.freshItem.pznm = yy+MM+DD+hh+mf
    this.freshItem.pzrq = yy+MM+DD
    this.freshItem.lxbh = '01'
    this.freshItem.bmbh = '1010'
    this.freshItem.pzbh = '9999'

      // 获取对方单位列表
      /*this.axios.all([
        this.axios.get(getdfdwURI, {params: {sort: 'rank.asc'}})
      ]).then(
          this.axios.spread(
              (rspCwlk) => {
                console.log(rspCwlk.data.items)
                //this.dfdwItems = rspCwlk.data.items
              }
          )
      )*/
  },
  methods: {
    onSelectDate() {
      this.item.lkrq = this.lkrq
      this.item.lkrq = this.item.lkrq.split("-").join("")
    },
  },
}
</script>

<style scoped>

</style>